import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Interactive map banner',
    },
  },
};


export function InteractiveMapHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="interactivemaphero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Interactive map banner"
    >
      <InnerPageHeroSubtitle path="interactivemaphero.subtitle" />
      <RichTextContent
        path="interactivemaphero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="interactivemaphero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="interactivemaphero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'InteractiveMapHero',
  displayName: 'Interactive Map Hero',
  tokens: {
    'interactivemaphero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Interactive Map</p>',
    },
    'interactivemaphero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue: '<p>Explore the Area in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'interactivemaphero.bg_image': bgImageDef,
  },
};

(InteractiveMapHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default InteractiveMapHero;
